!((document, Drupal, $, debounce, once) => {
  'use strict';

  /**
   * This function is set up to toggle the alert message shut.
   */
  Drupal.behaviors.fixedHeaderHeights = {
    attach: function(context) {
      const $layoutContainer = $('.layout-container', context);
      const $mainContainer = $('main', context);
      const $environmentIndicator = $('#environment-indicator');
      const $hero = $('.hero', context);
      const $subbrand = $('.subbrand-banner', context);
      const $header = $('.header', context);
      const $headerTop = $('.header__row-top', context);
      const $headerAlert = $('header .alert-messages-container');
      const $closeBtn = $headerAlert.find('.close-btn');

      let envHeight = 0;
      let alertHeight = 0;
      let subbrandHeight = 0;
      let combinedHeights = 0;

      /**
       * @returns {any} Adds Spacing to Layout Container
       */
      function addSpacingToContent() {
        // Briefly wait before executing the spacing logic to allow for all
        // elements to be positioned in the DOM before performing calculations.
        setTimeout(() => {
          envHeight = $environmentIndicator.length > 0 ? 34 : 0;
          alertHeight = $headerAlert.length > 0 && $headerAlert.outerHeight();

          subbrandHeight = 0;
          if ($subbrand.length > 0 && $subbrand.is(':visible')) {
            if (
              $(window).outerWidth() < 1200 ||
              !$subbrand.hasClass('subbrand-banner--in-hero')
            ) {
              subbrandHeight = $subbrand.outerHeight();
            }
          }

          combinedHeights = envHeight + alertHeight;

          $headerAlert.css({
            'margin-top': `${envHeight}px`
          });

          if ($(window).outerWidth() > 767) {
            $header.css({
              'margin-top': `${combinedHeights}px`,
              'padding-top': '0'
            });
            $mainContainer.css({
              'padding-top': `${combinedHeights +
                $header.outerHeight() +
                subbrandHeight}px`
            });
          }
          else {
            $header.css({
              'margin-top': '0',
              'padding-top': `${combinedHeights}px`
            });
            $mainContainer.css({
              'padding-top': `${combinedHeights + $headerTop.outerHeight()}px`
            });
          }
        }, 10);
      }

      // Sets the padding on the top of the main content
      // to reflect the height of the alert box and header
      // above it. This is being done because these elements
      // are position fixed.
      if (context === document) {
        $(document).ready(function() {
          addSpacingToContent();

          if ($layoutContainer.hasClass('nagaunee')) {
            if ($hero.length > 0 && $hero.hasClass('subbrand')) {
              $hero.addClass('hero--internal');
            }
            $subbrand.addClass('subbrand-banner--nagaunee');
          }
          else if ($layoutContainer.hasClass('regenstein')) {
            if ($hero.length > 0 && $hero.hasClass('subbrand')) {
              $hero.addClass('hero--internal');
            }
            $subbrand.addClass('subbrand-banner--regenstein');
          }
          else if ($layoutContainer.hasClass('windy')) {
            if ($hero.length > 0 && $hero.hasClass('subbrand')) {
              $hero.addClass('hero--internal');
            }
            $subbrand.addClass('subbrand-banner--windy');
          }

          // Closing the Alert updates the styling
          // on the header and main container.
          $(document).on('click', [$closeBtn, $headerAlert], function() {
            addSpacingToContent();
          });
        });
      }

      var width = $(window).outerWidth();

      $(window).on('orientationchange resize', function() {
        // run only when width changed
        if ($(this).outerWidth() !== width) {
          width = $(this).outerWidth();
          debounce(addSpacingToContent(), 100, false);
        }
      });
    }
  };

  /*
   * Show/hide
   */
  Drupal.behaviors.showHide = {
    attach: function(context) {
      $('.show-hide', context).each(function() {
        $(this).data('text-closed', $(this).text());
      });

      once('showHide', '.show-hide', context).forEach(function(el) {
        el.on('click', function(e) {
          e.preventDefault();
          const $this = $(this);

          const target = $this.data('show-hide-target');

          if ($this.hasClass('open')) {
            $this.text($this.data('text-closed'));
            $this.removeClass('open');
          }
          else {
            $this.text($this.data('text-open'));
            $this.addClass('open');
          }

          $('#' + target).slideToggle('fast', function() {
            $(window).trigger('resize.omegaequalheights');
          });
        });
      });
    }
  };

  Drupal.behaviors.svgRoles = {
    attach: function() {
      document.querySelectorAll('svg:not([aria-hidden])').forEach((svg) => {
        svg.setAttribute('aria-hidden', 'true');
      });
    }
  };
})(document, Drupal, jQuery, Drupal.debounce, once);
